const domainCampaign = process.env.REACT_APP_BASE_URL;
const END_POINTS = {
  GET_CAMPAIGN_INFO: domainCampaign + "/psqr/campaigns/check",
  REQUEST_OTP: domainCampaign + "/otp/RequestOtp",
  VERIFY_OTP: domainCampaign + "/otp/VerifyOTP",
  VALIDATE_CAMPAIGN: domainCampaign + "/campaign/check",
  CHECK_TRANSACTION_ID: domainCampaign + `/transaction/check`,
  GENERATE_TRANSACTION_ID: domainCampaign + `/transaction/generate`,
  CHECK_PHONE_NUMBER: domainCampaign + `/phone/check`,
  RECEIVED_REPORT: domainCampaign + `/campaign/join`,
};

export { END_POINTS };
